import { render, staticRenderFns } from "./bannedDetail.vue?vue&type=template&id=0376a0da&scoped=true"
import script from "./bannedDetail.vue?vue&type=script&lang=js"
export * from "./bannedDetail.vue?vue&type=script&lang=js"
import style0 from "./bannedDetail.vue?vue&type=style&index=0&id=0376a0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0376a0da",
  null
  
)

export default component.exports